import Feeds from "./Feeds";

export function UpdatesFeed(props) {
  return (
    <div className="UpdatesFeed">
      <Feeds />
    </div>
  )
}

export default UpdatesFeed;